/* eslint-disable max-len */
import React, { useCallback, useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';
import { BusinessDetailsTableActionComponent, LocationTableActionComponent, WatercraftOperatorsTableActionComponent } from 'ml-capability-quoteandbind-common-react'
import PropTypes from 'prop-types';
import DriverTableComponent from '../../../gw-capability-quoteandbind-common-react/components/DriverTableComponent/DriverTableComponent';
import PUPVehicleTableComponent from '../PUPVehicleTableComponent/PUPVehicleTableComponent';
import metadata from './QuotePageUmbExposuresComponent.metadata.json5';
import messages from './QuotePageUmbExposuresComponent.messages';

// eslint-disable-next-line no-warning-comments
const PUP_VEHICLE_DRIVER_PAGE = '/exposures';
const PUP_WATERCARFT_LOCATION_PAGE = '/properties';
const ACTION_ADD_DRIVER = 'add';
const ACTION_REMOVE_DRIVER = 'remove';
const ACTION_EDIT_DRIVER = 'edit';
const ACTION_ADD_LOCATION = 'addLocation';
const ACTION_ADD_BUSINESS_ACTIVITY = 'addBusinessActivity';

function QuotePageUmbExposuresComponent(props) {
    const {
        submissionVM,
        navigateToStep,
        updateWizardData,
        isGateway,
        viewModelService
    } = props;

    const translator = useTranslator();
    const vehicleOperators = _.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicleOperators.value', []);
    const {
        getRatedDriverType,
        getExcludedDriverType,
        getHouseholdDriverType,
        getNonDriverType,
        getPermittedDriverType,
        getOutOfHouseholdDriverType
    } = MLDriverVehicleUtil();
    const ratedDriverType = getRatedDriverType();
    const excludedDriverType = getExcludedDriverType();
    const householdDriverType = getHouseholdDriverType();
    const nonDriverType = getNonDriverType();
    const permittedDriverType = getPermittedDriverType();
    const outOfHouseholdDriverType = getOutOfHouseholdDriverType();
    const allowedDriverTypes = [
    householdDriverType,
    nonDriverType,
    permittedDriverType,
    outOfHouseholdDriverType
    ];
    const ratedVehicleOperators = vehicleOperators.filter((d) => d.driverType === ratedDriverType);
    const householdMembers = vehicleOperators.filter((d) => allowedDriverTypes.includes(d.driverType));
    const excludedVehicleOperators = vehicleOperators.filter((d) => d.driverType === excludedDriverType);
    const canExcludeDrivers = _.get(submissionVM, 'baseData.canExcludeDrivers_ML.value', true);

    const [vehiclesVal, updateVehiclesVal] = useState([]);

    const isVehicleValid = useCallback((vehicle) => {
        if (!vehicle) {
            return true;
        }
        return vehicle.aspects.valid && vehicle.aspects.subtreeValid;
    }, []);

    const checkVehiclesValidity = useCallback(() => {
        const vehicles = _.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicles.children', [])
        if (!_.isEmpty(vehicles)) {
            vehicles.forEach((vehicle) => {
                vehicle.value.error = !isVehicleValid(vehicle);
            });
        }
        return vehicles;
    }, [isVehicleValid, submissionVM]);

    useEffect(() => {
        checkVehiclesValidity();

        const vehiclesValue = _.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicles.value', [])
        updateVehiclesVal(vehiclesValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const goToPUPVehicleDriverPage = useCallback(() => {
        navigateToStep(PUP_VEHICLE_DRIVER_PAGE);
    }, [navigateToStep]);

    const goToPupWatercraftLocationPage = useCallback(() => {
        navigateToStep(PUP_WATERCARFT_LOCATION_PAGE);
    }, [navigateToStep]);

    const onAddDriver = useCallback((type) => {
        const data = {
            action: ACTION_ADD_DRIVER,
            type
        };
        navigateToStep(PUP_VEHICLE_DRIVER_PAGE, data);
    }, [navigateToStep]);

    const onEditDriver = useCallback((driverToEdit, type) => {
        const data = {
            action: ACTION_EDIT_DRIVER,
            model: driverToEdit,
            type
        };
        navigateToStep(PUP_VEHICLE_DRIVER_PAGE, data);
    }, [navigateToStep]);


    const onRemoveDriver = useCallback((driverToRemove, type) => {
        const data = {
            action: ACTION_REMOVE_DRIVER,
            model: driverToRemove,
            type
        };
        
        navigateToStep(PUP_VEHICLE_DRIVER_PAGE, data);
    }, [navigateToStep]);

    const onAddLocation = useCallback(() => {
        const data = {
            action: ACTION_ADD_LOCATION
        };
        navigateToStep(PUP_WATERCARFT_LOCATION_PAGE, data);
    }, [navigateToStep]);

    const onAddBusinessActivity = useCallback(() => {
        const data = {
            action: ACTION_ADD_BUSINESS_ACTIVITY
        };
        navigateToStep(PUP_WATERCARFT_LOCATION_PAGE, data);
    }, [navigateToStep]);


    const resolvers = {
        resolveComponentMap: {
            pupvehicletablecomponent: PUPVehicleTableComponent,
            drivertablecomponent: DriverTableComponent,
            watercraftoperatorstableactioncomponent: WatercraftOperatorsTableActionComponent,
            locationTableActionComponent: LocationTableActionComponent,
            businessdetailstableactioncomponent: BusinessDetailsTableActionComponent
        }
    };
    
    const overrides = {
        vehiclesTable: {
            list: vehiclesVal,
            goBackToStep: goToPUPVehicleDriverPage,
            isWatercraft: false
        },
        vehicleOperatorsTableRated: {
            list: ratedVehicleOperators,
            isUmb: true,
            hideAdd: false,
            hideEdit: false,
            hideRemove: false,
            title: translator(messages.drivers),
            onAdd: onAddDriver,
            onEdit: onEditDriver,
            onRemove: onRemoveDriver,
            addLabel: translator(messages.addDriver),
            driverType: ratedDriverType,
            showEndHr: false
        },
        excludedHr: {
            visible: canExcludeDrivers
        },
        vehicleOperatorsTableExcluded: {
            visible: canExcludeDrivers,
            isUmb: true,
            list: excludedVehicleOperators,
            hideAdd: false,
            hideEdit: false,
            hideRemove: false,
            title: translator(messages.excludedDrivers),
            onAdd: onAddDriver,
            onEdit: onEditDriver,
            onRemove: onRemoveDriver,
            addLabel: translator(messages.addExclDriver),
            driverType: excludedDriverType,
            subtitle: translator(messages.excludedDriversSubtitle),
            helpTitle: !isGateway ? translator(messages.exclDriverHelpTitle) : undefined,
            helpDescription: !isGateway ? translator(messages.exclDriverHelpDesc) : undefined,
            showEndHr: false,
            titleTooltipHeader: isGateway ? translator(messages.exclDriverTitleTooltipHeader) : undefined,
            titleTooltipContent: isGateway ? translator(messages.exclDriverTitleTooltipContent) : undefined,
        },
        vehicleOperatorsHouseholdMembers: {
            list: householdMembers,
            isUmb: true,
            hideAdd: false,
            hideEdit: false,
            hideRemove: false,
            title:  submissionVM.isModernProduct_Ext?.value ? translator(messages.nonDrivers) : translator(messages.householdMembers),
            onAdd: onAddDriver,
            onEdit: onEditDriver,
            onRemove: onRemoveDriver,
            addLabel: submissionVM.isModernProduct_Ext?.value ? translator(messages.addNonDriver) : translator(messages.addHouseholdMember),
            driverType: householdDriverType,
            subtitle: submissionVM.isModernProduct_Ext?.value ? translator(messages.nonDriversSubtitle) : translator(messages.householdMembersSubtitle),
            showEndHr: false
        },
        watercraftsTable: {
            list: _.get(submissionVM, 'lobData.personalUmbrella.coverables.watercrafts.value', []),
            goBackToStep: goToPupWatercraftLocationPage,
            isWatercraft: true
        },
        watercraftOperatorsComp: {
            submissionVM,
            updateWizardData,
            viewModelService
        },
        locationTableActionComponent: {
            submissionVM,
            updateWizardData,
            showAnimalExclusionWarningMessage: _.noop,
            quotePageAddFunction: onAddLocation,
            quotePageEditRemoveFunction: goToPupWatercraftLocationPage
        },
        businessTableActionComponent: {
            submissionVM,
            updateWizardData,
            quotePageAddFunction: onAddBusinessActivity,
            quotePageEditRemoveFunction: goToPupWatercraftLocationPage,
            viewModelService
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

QuotePageUmbExposuresComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    navigateToStep: PropTypes.func.isRequired,
    updateWizardData: PropTypes.func.isRequired,
    isGateway: PropTypes.bool.isRequired
};

export default QuotePageUmbExposuresComponent;
